(() => {
  const storagePrefix = 'rielli-newsletter-dismissed-';

  class RielliNewsletterDrawer {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.storageKey = `${storagePrefix}${this.sectionId}`;
      this.designMode = root.dataset.designMode === 'true';
      this.delay = Number(root.dataset.delay || 0);
      this.frequencyDays = Number(root.dataset.frequency || 0);
      this.closeTimer = null;
      this.bind();
      this.schedule();
    }

    bind() {
      this.root.querySelector('[data-rielli-signup-close]')?.addEventListener('click', () => this.close(true));

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.root.hidden) this.close(true);
      });

      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.sectionId) this.open();
      });
    }

    schedule() {
      const success = this.root.querySelector('[data-rielli-signup-success]');

      if (success) {
        success.closest('form')?.classList.add('has-success');
        this.open();
        return;
      }

      if (!this.designMode && this.isSuppressed()) return;
      window.setTimeout(() => this.open(), this.designMode ? 100 : this.delay);
    }

    isSuppressed() {
      if (!this.frequencyDays) return false;

      try {
        const dismissedAt = Number(localStorage.getItem(this.storageKey) || 0);
        return Date.now() - dismissedAt < this.frequencyDays * 86400000;
      } catch (error) {
        return false;
      }
    }

    open() {
      if (this.closeTimer) window.clearTimeout(this.closeTimer);
      this.root.hidden = false;
      document.documentElement.classList.add('rielli-signup-is-open');
      window.requestAnimationFrame(() => this.root.classList.add('is-visible'));
    }

    close(suppress) {
      this.root.classList.remove('is-visible');
      document.documentElement.classList.remove('rielli-signup-is-open');

      if (suppress && !this.designMode) {
        try {
          localStorage.setItem(this.storageKey, String(Date.now()));
        } catch (error) {
          // The drawer can still close when storage is unavailable.
        }
      }

      this.closeTimer = window.setTimeout(() => {
        this.root.hidden = true;
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 375);
    }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-rielli-signup]:not([data-rielli-signup-ready])').forEach((root) => {
      root.dataset.rielliSignupReady = 'true';
      new RielliNewsletterDrawer(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
